module.exports = __webpack_public_path__ + "static/media/card-gator-protect-es.5cf5b09a.png";